module.exports = __webpack_public_path__ + "static/Kelena_kennedy-d9e899b1e36bb9aba883af7462447944.jpg";